import { Component, EventEmitter, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { SuperAdminService } from './super-admin/super-admin.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from './core/ui-blocking.service';
import { ToastNotificationService } from './core/toast-notification.service';
import { DumbAdmin } from './super-admin/DTOs/dumb-admin';
import { AddEditSuperAdminModalComponent } from './super-admin/Modals/add-edit-super-admin-modal.component';
import { AuthService } from './core/auth.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {

  constructor(private superAdminService: SuperAdminService
    , private authService: AuthService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal
    , private router: Router
    , private renderer: Renderer2) {
    router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChange());
  }
  myAdmin: DumbAdmin = new DumbAdmin();
  headerText = "";
  hideSidebar: boolean = false;

  @Output() togglingMobileMenu = new EventEmitter();


  ngOnInit() {
    this.handleRouteChange();
    // this.getmyAdminInfo();
    this.myAdmin.firstName = localStorage.getItem('userFirstName');
    this.myAdmin.lastName = localStorage.getItem('userLastName');
    this.myAdmin.fullName = this.myAdmin.firstName + " " + this.myAdmin.lastName;
    this.myAdmin.contactId = localStorage.getItem('contactId');
    this.myAdmin.contactType = localStorage.getItem('contactType');
    this.myAdmin.emailAddress = localStorage.getItem('userEmailAddress');
  }


  handleRouteChange = () => {
      if (!this.router.url.includes('login') && !this.router.url.includes('sign-up'))
          this.getmyAdminInfo();
      if (this.router.url.includes('super-admin-management'))
          this.headerText = "Super-Admins";
      else if (this.router.url.includes("super-admin-member-management"))
          this.headerText = "Members";
      else if (this.router.url.includes("pending-applications"))
          this.headerText = "Pending Applications";
      else if (this.router.url.includes("user-management"))
          this.headerText = "My Members";
      else if (this.router.url.includes("membership-management"))
          this.headerText = "My Membership";
      else if (this.router.url.includes("pending-news"))
          this.headerText = "News Submissions";
      else if (this.router.url.includes("pending-letters"))
          this.headerText = "Pending Letters";
      else if (this.router.url.includes("pending-ads"))
          this.headerText = "Ad Submissions";
      else if (this.router.url.includes("pending-discounts"))
          this.headerText = "Discount Submissions";
      else if (this.router.url.includes("submit-member-ad"))
          this.headerText = "Submit Ad";
      else if (this.router.url.includes("member-ads"))
          this.headerText = "Submit Ad";
      else if (this.router.url.includes("submit-member-news"))
          this.headerText = "Submit News";
      else if (this.router.url.includes("submit-member-discount"))
          this.headerText = "Submit Discount";
      else if (this.router.url.includes("dashboard"))
          this.headerText = "My Dashboard";
    else if (this.router.url.includes("submit-member-discount"))
      this.headerText = "Submit Discount";
    else if (this.router.url.includes("payment-history"))
      this.headerText = "Payment History";
    else if (this.router.url.includes("invoice-management"))
      this.headerText = "Invoices";
    else if (this.router.url.includes("non-invoice-payment"))
      this.headerText = "Invoice Payment";
    else if (this.router.url.includes("invoice-payment"))
      this.headerText = "Send a Payment";
    else if (this.router.url.includes("super-admin-resources"))
          this.headerText = "Resource Pages";
      else if (this.router.url.includes("chamber-perks"))
          this.headerText = "Chamber Perks";
      else if (this.router.url.includes("super-admin-settings"))
          this.headerText = "Settings";


  };
  getmyAdminInfo() {
    this.blockUI.start();
    this.superAdminService.getmyAdminInfo().subscribe({
      next: (data) => {
        this.myAdmin = data;
        localStorage.setItem('userFirstName', this.myAdmin.firstName);
        localStorage.setItem('userLastName', this.myAdmin.lastName);
        localStorage.setItem('contactType', this.myAdmin.contactType);
        localStorage.setItem('userEmailAddress', this.myAdmin.emailAddress);

      },
      error: (err) => {
        this.notificationService.error(err.error.message);
        console.log(err)
      },
      complete: () => {
        this.blockUI.stop();
      }
    });
  }

  showSideBar() {
    this.togglingMobileMenu.emit();
  }

  EditMyProfile() {
    const modalRef = this.modalService.open(AddEditSuperAdminModalComponent, { size: 'lg', backdrop: 'static' });
    this.myAdmin.isActive = true;
    modalRef.componentInstance.admin = this.myAdmin;
    modalRef.componentInstance.headerText = "My Info";
    modalRef.componentInstance.adding = false;
    modalRef.componentInstance.hideStatusToggle = true;
    if (this.myAdmin.contactType == 'BusinessUser')
      modalRef.componentInstance.isMemberAdmin = true;
    if (this.myAdmin.contactType == 'SuperAdmin')
      modalRef.componentInstance.isMemberAdmin = false;

    modalRef.result.then(response => {
      this.getmyAdminInfo();
    })
      .catch(err => {

      }).finally();
  }

  logout() {
    this.authService.logout();
  }
}
